import React from 'react';
import { Alert, Button, CircularProgress, Typography } from '@mui/material';
import { ASSIGNED_MOCK_LABEL } from '../../utils/mockTestAccess';

export default function MockTestAccessStatus({ access, error, refresh }) {
  if (error) return <Alert severity="error" action={<Button onClick={refresh}>Retry</Button>}>{error}</Alert>;
  if (!access) return <CircularProgress size={24} aria-label="Checking mock-test access" />;
  return access.restricted ? <Typography sx={{ my: 2 }}>{ASSIGNED_MOCK_LABEL}</Typography> : null;
}
